import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Container, Input, Header } from 'semantic-ui-react';
import SortByDistanceButton from './SortByDistanceButton';
import { AsPropType } from '../../../services/proptypes';
var defaultProps = {
  distanceLoading: false,
  searchHeaderAs: 'h2',
  searchPlaceholder: '123 Main Street, Boston MA',
  searchQuery: ''
};
var SearchLocations = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SearchLocations, _React$PureComponent);
  var _super = _createSuper(SearchLocations);
  function SearchLocations() {
    _classCallCheck(this, SearchLocations);
    return _super.apply(this, arguments);
  }
  _createClass(SearchLocations, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        searchHeader = _this$props.searchHeader,
        searchHeaderAs = _this$props.searchHeaderAs,
        onSearchChange = _this$props.onSearchChange,
        searchQuery = _this$props.searchQuery,
        searchPlaceholder = _this$props.searchPlaceholder,
        locationSortingStatus = _this$props.locationSortingStatus,
        onSort = _this$props.onSort,
        distanceLoading = _this$props.distanceLoading;
      return /*#__PURE__*/React.createElement(Container, {
        className: "fm-search-locations"
      }, /*#__PURE__*/React.createElement(Header, {
        as: searchHeaderAs
      }, searchHeader), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
        fluid: true,
        onChange: onSearchChange,
        value: searchQuery,
        action: {
          content: 'Search',
          primary: true
        },
        placeholder: searchPlaceholder
      }), /*#__PURE__*/React.createElement(SortByDistanceButton, {
        locationSortingStatus: locationSortingStatus,
        onSort: onSort,
        loading: distanceLoading
      })));
    }
  }]);
  return SearchLocations;
}(React.PureComponent);
export { SearchLocations as default };
SearchLocations.defaultProps = defaultProps;